import { sendMagicLink } from "../auth/auth";
import { h, mount } from "../lib/dom";

export function renderLogin(root: HTMLElement): void {
  let busy = false;
  let message: { kind: "ok" | "error"; text: string } | null = null;

  const messageEl = h("p", { class: "auth-message", "aria-live": "polite" });
  const emailInput = h("input", {
    type: "email",
    name: "email",
    autocomplete: "email",
    required: true,
    placeholder: "operator@mypickyfork.com",
    class: "input",
  }) as HTMLInputElement;
  const button = h("button", { type: "submit", class: "btn btn-primary" }, "Send magic link") as HTMLButtonElement;

  function paintMessage(): void {
    if (!message) {
      messageEl.textContent = "";
      messageEl.className = "auth-message";
      return;
    }
    messageEl.textContent = message.text;
    messageEl.className = `auth-message auth-message-${message.kind}`;
  }

  const form = h(
    "form",
    {
      class: "auth-form",
      onsubmit: async (e: Event) => {
        e.preventDefault();
        if (busy) return;
        busy = true;
        button.disabled = true;
        button.textContent = "Sending…";
        const result = await sendMagicLink(emailInput.value);
        busy = false;
        button.disabled = false;
        button.textContent = "Send magic link";
        message = result.ok
          ? { kind: "ok", text: "Check your email. The link signs you straight in." }
          : { kind: "error", text: result.error };
        paintMessage();
      },
    },
    h("label", { for: "email", class: "label" }, "Operator email"),
    emailInput,
    button,
    messageEl,
  );

  mount(
    root,
    h(
      "main",
      { class: "auth-screen" },
      h(
        "div",
        { class: "auth-card" },
        h("p", { class: "auth-eyebrow" }, "MyPickyFork"),
        h("h1", { class: "auth-title" }, "Operator sign-in"),
        h(
          "p",
          { class: "auth-lede" },
          "Enter your operator email. We will send you a magic link. Only invited emails work; nobody else can sign in.",
        ),
        form,
      ),
    ),
  );
}
